import React, { useState } from "react";

function TelegramDecoder() {
  const [inputValue, setInputValue] = useState("");
  const [selection, setSelection] = useState("Format 50"); // Default selection

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSelectionChange = (event) => {
    setSelection(event.target.value);
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  };

  const thTdStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  };

  // Define a custom style for the nested descriptions to ensure alignment and readability
  const nestedDescriptionStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "4px", // Adjust as needed for spacing between items
  };

  const nestedItemStyle = {
    display: "flex",
    justifyContent: "space-between",
  };

  return (
    <div style={{ margin: "20px" }}>
      <select
        onChange={handleSelectionChange}
        value={selection}
        style={{ margin: "20px 0", padding: "10px" }}
      >
        <option value="Format 10">
          Format 10 – Crane / TC / Lifter order feedback message
        </option>
        <option value="Format 40">
          Format 40 – Tray Crane 1 LDU order feedback message
        </option>
        <option value="Format 50">
          Format 50 – Tray Crane 2 LDU order feedback message
        </option>
        <option value="Inbound and Conveyors">Inbound and Conveyors</option>
      </select>

      {selection === "Format 10" ? (
        <>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Enter text here"
            style={{
              padding: "10px",
              margin: "10px 0",
              width: "calc(100% - 22px)",
            }}
          />
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thTdStyle}>Placeholder</th>
                <th style={thTdStyle}>Byte Location</th>
                <th style={thTdStyle}>Value</th>
                <th style={thTdStyle}>Potential Values</th>
                <th style={thTdStyle}>Description of Values</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={thTdStyle}>qq</td>
                <td style={thTdStyle}>Byte 1-2</td>
                <td style={thTdStyle}>{inputValue.substring(0, 2)}</td>
                <td style={thTdStyle}>
                  &apos;00&apos; - &apos;99&apos;, or MF
                </td>
                <td style={thTdStyle}>Source of message (GC Group Control)</td>
              </tr>
              <tr>
                <td style={thTdStyle}>zz</td>
                <td style={thTdStyle}>Byte 3-4</td>
                <td style={thTdStyle}>{inputValue.substring(2, 4)}</td>
                <td style={thTdStyle}>
                  &apos;00&apos; - &apos;99&apos;, or MF
                </td>
                <td style={thTdStyle}>Destination of message</td>
              </tr>
              <tr>
                <td style={thTdStyle}>mm</td>
                <td style={thTdStyle}>Byte 5-6</td>
                <td style={thTdStyle}>{inputValue.substring(4, 6)}</td>
                <td style={thTdStyle}>&apos;00&apos; - &apos;99&apos;</td>
                <td style={thTdStyle}>Meldepunkt/Action Point</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ll</td>
                <td style={thTdStyle}>Byte 7-8</td>
                <td style={thTdStyle}>{inputValue.substring(6, 8)}</td>
                <td style={thTdStyle}>&apos;00&apos; - &apos;99&apos;</td>
                <td style={thTdStyle}>Laufnummer/Process number</td>
              </tr>
              <tr>
                <td style={thTdStyle}>t</td>
                <td style={thTdStyle}>Byte 9</td>
                <td style={thTdStyle}>{inputValue.substring(8, 9)}</td>
                <td style={thTdStyle}>
                  &apos;0&apos;, &apos;1&apos;, &apos;2&apos;, &apos;3&apos;,
                  &apos;4&apos;, &apos;5&apos;, &apos;R&apos;, &apos;X&apos;
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                      LDU 1 Order type
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos; - No order</span>
                      <span>Only positioning to the given coordinate</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;1&apos; - Test order</span>
                      <span>
                        PLC delivers the occupation state of the specified
                        storage slot
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;2&apos; - Loading</span>
                      <span>Loading operation</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;3&apos; - Unloading</span>
                      <span>Unloading operation</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;4&apos; - Combined order</span>
                      <span>
                        Combined order: unloading on unload position, loading on
                        loading position
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;5&apos; - Load through</span>
                      <span>
                        Load through from input position to output position,
                        only on load-unload positions
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;R&apos; - Reset order</span>
                      <span>
                        Reset the actual order at the PLC (Attention: sequence
                        number always &apos;00&apos;)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;X&apos; - LDU blocked</span>
                      <span>LDU blocked (deactivated in PLC)</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>t</td>
                <td style={thTdStyle}>Byte 10</td>
                <td style={thTdStyle}>{inputValue.substring(9, 10)}</td>
                <td style={thTdStyle}>Same as Byte 9</td>
                <td style={thTdStyle}>
                  LDU 2 Order type (see Byte 9 for descriptions)
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>q</td>
                <td style={thTdStyle}>Byte 11</td>
                <td style={thTdStyle}>{inputValue.substring(10, 11)}</td>
                <td style={thTdStyle}>
                  &apos;P&apos;
                  <br />
                  &apos;A&apos;
                  <br />
                  &apos;H&apos;
                  <br />
                  &apos;B&apos;
                  <br />
                  &apos;I&apos;
                  <br />
                  &apos;W&apos;
                  <br />
                  &apos;L&apos;
                  <br />
                  &apos;V&apos;
                  <br />
                  &apos;X&apos;
                  <br />
                  &apos;U&apos;
                  <br />
                  &apos;1&apos;
                  <br />
                  &apos;2&apos;
                  <br />
                  &apos;G&apos;
                  <br />
                  &apos;K&apos;
                  <br />
                  &apos;D&apos;
                  <br />
                  &apos;R&apos;
                  <br />
                  &apos;N&apos;
                  <br />
                  &apos;S&apos;
                  <br />
                  &apos;$&apos;
                </td>
                <td style={thTdStyle}>
                  Positive completion of given order
                  <br />
                  Order with other (former) sequence number is active at PLC
                  <br />
                  Height error (TU on fork is too high for given coordinate)
                  <br />
                  Width error (TU on fork is too wide for given coordinate)
                  <br />
                  Length error (TU on fork is too long for given coordinate)
                  <br />
                  Weight error (TU on fork is too heavy for given coordinate)
                  <br />
                  Storage slot empty (only if order type is &apos;1&apos; or
                  feedback reaction is &apos;2&apos; without fault indication)
                  <br />
                  Storage slot occupied
                  <br />
                  Occupation error (required occupation state is not equal to
                  real occupation state)
                  <br />
                  Unexecutable order (e.g., wrong occupation of storage slot)
                  <br />
                  Storage slot is occupied at depth 1 (only if order type is
                  &apos;1&apos;)
                  <br />
                  Storage slot is occupied at depth 2 (only if order type is
                  &apos;1&apos;)
                  <br />
                  Storage slot locked (constructional locked)
                  <br />
                  Wrong coordinates (invalid value range)
                  <br />
                  Wrong double order (only if two forks exist)
                  <br />
                  Acknowledge to order type &apos;R&apos; (reset from MFC)
                  <br />
                  Reset done
                  <br />
                  Jam/fault, because &quot;ready to transfer&quot;- signal is
                  missing (order not executed)
                  <br />
                  Logical fault in order (e.g., unload of two TU in depth 1,
                  wrong order type)
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>q</td>
                <td style={thTdStyle}>Byte 12</td>
                <td style={thTdStyle}>{inputValue.substring(11, 12)}</td>
                <td style={thTdStyle}>
                  &apos;P&apos; - Positive completion
                  <br />
                  &apos;A&apos; - Order with other sequence active
                  <br />
                  &apos;H&apos; - Height error
                  <br />
                  &apos;B&apos; - Width error
                  <br />
                  &apos;I&apos; - Length error
                  <br />
                  &apos;W&apos; - Weight error
                  <br />
                  &apos;L&apos; - Storage slot empty
                  <br />
                  &apos;V&apos; - Storage slot occupied
                  <br />
                  &apos;X&apos; - Occupation error
                  <br />
                  &apos;U&apos; - Unexecutable order
                  <br />
                  &apos;1&apos; - Storage slot occupied at depth 1<br />
                  &apos;2&apos; - Storage slot occupied at depth 2<br />
                  &apos;G&apos; - Storage slot locked
                  <br />
                  &apos;K&apos; - Wrong coordinates
                  <br />
                  &apos;D&apos; - Wrong double order
                  <br />
                  &apos;R&apos; - Acknowledge reset
                  <br />
                  &apos;N&apos; - Reset done
                  <br />
                  &apos;S&apos; - Jam/fault
                  <br />
                  &apos;$&apos; - Logical fault
                </td>
                <td style={thTdStyle}>
                  LDU 2 Order feedback (same as Byte 11)
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 13</td>
                <td style={thTdStyle}>{inputValue.substring(12, 13)}</td>
                <td style={thTdStyle}>
                  &apos;0&apos; - 0% speed reduction
                  <br />
                  &apos;1&apos; - 6.25% speed reduction
                  <br />
                  &apos;2&apos; - 12.50% speed reduction
                  <br />
                  &apos;3&apos; - 18.75% speed reduction
                  <br />
                  &apos;4&apos; - 25.00% speed reduction
                  <br />
                  &apos;5&apos; - 31.25% speed reduction
                  <br />
                  &apos;6&apos; - 37.50% speed reduction
                  <br />
                  &apos;7&apos; - 43.75% speed reduction
                  <br />
                  &apos;8&apos; - 50.00% speed reduction
                  <br />
                  &apos;9&apos; - 56.25% speed reduction
                  <br />
                  &apos;:&apos; - 62.50% speed reduction
                  <br />
                  &apos;;&apos; - 68.75% speed reduction
                  <br />
                  &apos;&lt;&apos; - 75.00% speed reduction
                  <br />
                  &apos;=&apos; - 81.25% speed reduction
                  <br />
                  &apos;&gt;&apos; - 87.50% speed reduction
                  <br />
                  &apos;?&apos; - 93.75% speed reduction
                </td>
                <td style={thTdStyle}>
                  Reduction in speed for X-axis (Byte 13)
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 14</td>
                <td style={thTdStyle}>{inputValue.substring(13, 14)}</td>
                <td style={thTdStyle}>Same as Byte 13</td>
                <td style={thTdStyle}>
                  LDU 1 Reduction in speed (see Byte 13 for descriptions)
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 15</td>
                <td style={thTdStyle}>{inputValue.substring(14, 15)}</td>
                <td style={thTdStyle}>Same as Byte 13</td>
                <td style={thTdStyle}>
                  LDU 2 Reduction in speed (see Byte 13 for descriptions)
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>t</td>
                <td style={thTdStyle}>Byte 16</td>
                <td style={thTdStyle}>{inputValue.substring(15, 16)}</td>
                <td style={thTdStyle}>
                  &apos;0&apos; - Feedback after fault
                  <br />
                  &apos;1&apos; - Feedback during fault
                  <br />
                  &apos;2&apos; - Feedback after operation without fault
                  <br />
                  &apos;3&apos; - Feedback during operation without fault
                </td>
                <td style={thTdStyle}>Type of feedback reaction</td>
              </tr>
              <tr>
                <td style={thTdStyle}>xxx</td>
                <td style={thTdStyle}>Byte 17-19</td>
                <td style={thTdStyle}>{inputValue.substring(16, 19)}</td>
                <td style={thTdStyle}>&apos;000&apos; - &apos;254&apos;</td>
                <td style={thTdStyle}>X-coordinate of source</td>
              </tr>
              <tr>
                <td style={thTdStyle}>yyy</td>
                <td style={thTdStyle}>Byte 20-22</td>
                <td style={thTdStyle}>{inputValue.substring(19, 22)}</td>
                <td style={thTdStyle}>&apos;000&apos; - &apos;254&apos;</td>
                <td style={thTdStyle}>Y-coordinate of source</td>
              </tr>
              <tr>
                <td style={thTdStyle}>z</td>
                <td style={thTdStyle}>Byte 23</td>
                <td style={thTdStyle}>{inputValue.substring(22, 23)}</td>
                <td style={thTdStyle}>
                  &apos;0&apos; - No side
                  <br />
                  &apos;L&apos; - Left rack side
                  <br />
                  &apos;R&apos; - Right rack side
                </td>
                <td style={thTdStyle}>LDU 1 Rack side order</td>
              </tr>
              <tr>
                <td style={thTdStyle}>Aa</td>
                <td style={thTdStyle}>Byte 24-25</td>
                <td style={thTdStyle}>{inputValue.substring(23, 25)}</td>
                <td style={thTdStyle}>Dynamic</td>
                <td style={thTdStyle}>LDU 1 Number of TU to load/unload</td>
              </tr>
              <tr>
                <td style={thTdStyle}>Ttt</td>
                <td style={thTdStyle}>Byte 26-28</td>
                <td style={thTdStyle}>{inputValue.substring(25, 28)}</td>
                <td style={thTdStyle}>&apos;000&apos; - &apos;254&apos;</td>
                <td style={thTdStyle}>LDU 1 Load depth</td>
              </tr>
              <tr>
                <td style={thTdStyle}>Z</td>
                <td style={thTdStyle}>Byte 29</td>
                <td style={thTdStyle}>{inputValue.substring(28, 29)}</td>
                <td style={thTdStyle}>Same as Byte 23</td>
                <td style={thTdStyle}>LDU 2 Rack side order</td>
              </tr>
              <tr>
                <td style={thTdStyle}>aa</td>
                <td style={thTdStyle}>Byte 30-31</td>
                <td style={thTdStyle}>{inputValue.substring(29, 31)}</td>
                <td style={thTdStyle}>Dynamic</td>
                <td style={thTdStyle}>LDU 2 Number of TU to load/unload</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ttt</td>
                <td style={thTdStyle}>Byte 32-34</td>
                <td style={thTdStyle}>{inputValue.substring(31, 34)}</td>
                <td style={thTdStyle}>&apos;000&apos; - &apos;254&apos;</td>
                <td style={thTdStyle}>LDU 2 Load depth</td>
              </tr>
              <tr>
                <td style={thTdStyle}>s</td>
                <td style={thTdStyle}>Byte 35</td>
                <td style={thTdStyle}>{inputValue.substring(34, 35)}</td>
                <td style={thTdStyle}>Bit representation</td>
                <td style={thTdStyle}>
                  LDU 1: Nominal occupation before order start or real
                  occupation if order feedback (Byte 11) = &apos;X&apos;
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>S</td>
                <td style={thTdStyle}>Byte 36</td>
                <td style={thTdStyle}>{inputValue.substring(35, 36)}</td>
                <td style={thTdStyle}>Bit representation</td>
                <td style={thTdStyle}>
                  LDU 2: Nominal occupation before order start or real
                  occupation if order feedback (Byte 12) = &apos;X&apos;
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>H</td>
                <td style={thTdStyle}>Byte 37</td>
                <td style={thTdStyle}>{inputValue.substring(36, 37)}</td>
                <td style={thTdStyle}>&apos;1&apos; - &apos;3&apos;</td>
                <td style={thTdStyle}>LDU 1 Height of the conveyor good</td>
              </tr>
              <tr>
                <td style={thTdStyle}>B</td>
                <td style={thTdStyle}>Byte 38</td>
                <td style={thTdStyle}>{inputValue.substring(37, 38)}</td>
                <td style={thTdStyle}>&apos;1&apos; - &apos;2&apos;</td>
                <td style={thTdStyle}>LDU 1 Width of the conveyor good</td>
              </tr>
              <tr>
                <td style={thTdStyle}>L</td>
                <td style={thTdStyle}>Byte 39</td>
                <td style={thTdStyle}>{inputValue.substring(38, 39)}</td>
                <td style={thTdStyle}>&apos;1&apos; - &apos;2&apos;</td>
                <td style={thTdStyle}>LDU 1 Length of the conveyor goods</td>
              </tr>
              <tr>
                <td style={thTdStyle}>H</td>
                <td style={thTdStyle}>Byte 40</td>
                <td style={thTdStyle}>{inputValue.substring(39, 40)}</td>
                <td style={thTdStyle}>&apos;1&apos; - &apos;3&apos;</td>
                <td style={thTdStyle}>LDU 2 Height of the conveyor good</td>
              </tr>
              <tr>
                <td style={thTdStyle}>B</td>
                <td style={thTdStyle}>Byte 41</td>
                <td style={thTdStyle}>{inputValue.substring(40, 41)}</td>
                <td style={thTdStyle}>&apos;1&apos; - &apos;2&apos;</td>
                <td style={thTdStyle}>LDU 2 Width of the conveyor good</td>
              </tr>
              <tr>
                <td style={thTdStyle}>L</td>
                <td style={thTdStyle}>Byte 42</td>
                <td style={thTdStyle}>{inputValue.substring(41, 42)}</td>
                <td style={thTdStyle}>&apos;1&apos; - &apos;2&apos;</td>
                <td style={thTdStyle}>LDU 2 Length of the conveyor goods</td>
              </tr>
              <tr>
                <td style={thTdStyle}>p..p</td>
                <td style={thTdStyle}>Byte 43-52</td>
                <td style={thTdStyle}>{inputValue.substring(42, 52)}</td>
                <td style={thTdStyle}>Dynamic</td>
                <td style={thTdStyle}>TU 1 Identification number</td>
              </tr>
              <tr>
                <td style={thTdStyle}>p..p</td>
                <td style={thTdStyle}>Byte 53-62</td>
                <td style={thTdStyle}>{inputValue.substring(52, 62)}</td>
                <td style={thTdStyle}>Dynamic</td>
                <td style={thTdStyle}>TU 2 Identification number</td>
              </tr>
              {/* Continue with other rows as necessary */}
              <tr>
                <td style={thTdStyle}>{inputValue.substring(62)}</td>
                <td style={thTdStyle}>REST</td>
                <td style={thTdStyle}>From 62 onwards</td>
                <td style={thTdStyle}>TBD</td>
                <td style={thTdStyle}>
                  All remaining characters for the telegram
                </td>
              </tr>
            </tbody>
          </table>
        </>
      ) : null}

      {selection === "Format 40" ? (
        <>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Enter text here"
            style={{
              padding: "10px",
              margin: "10px 0",
              width: "calc(100% - 22px)",
            }}
          />
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thTdStyle}>Placeholder</th>
                <th style={thTdStyle}>Byte Location</th>
                <th style={thTdStyle}>Value</th>
                <th style={thTdStyle}>Description</th>{" "}
                {/* Renamed as requested */}
                <th style={thTdStyle}>Description of Values</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={thTdStyle}>qq</td>
                <td style={thTdStyle}>Byte 1-2</td>
                <td style={thTdStyle}>{inputValue.substring(0, 2)}</td>
                <td style={thTdStyle}>
                  &apos;00&apos; - &apos;99&apos;, or MF
                </td>
                <td style={thTdStyle}>Source of message (GC Group Control)</td>
              </tr>
              <tr>
                <td style={thTdStyle}>zz</td>
                <td style={thTdStyle}>Byte 3-4</td>
                <td style={thTdStyle}>{inputValue.substring(2, 4)}</td>
                <td style={thTdStyle}>
                  &apos;00&apos; - &apos;99&apos;, or MF
                </td>
                <td style={thTdStyle}>Destination of message</td>
              </tr>
              <tr>
                <td style={thTdStyle}>mm</td>
                <td style={thTdStyle}>Byte 5-6</td>
                <td style={thTdStyle}>{inputValue.substring(4, 6)}</td>
                <td style={thTdStyle}>&apos;00&apos; - &apos;99&apos;</td>
                <td style={thTdStyle}>Meldepunkt/Action Point</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ll</td>
                <td style={thTdStyle}>Byte 7-8</td>
                <td style={thTdStyle}>{inputValue.substring(6, 8)}</td>
                <td style={thTdStyle}>&apos;00&apos; - &apos;99&apos;</td>
                <td style={thTdStyle}>Laufnummer/Process number</td>
              </tr>
              <tr>
                <td style={thTdStyle}>t</td>
                <td style={thTdStyle}>Byte 9</td>
                <td style={thTdStyle}>{inputValue.substring(8, 9)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 1 Order type
                  </div>
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos; - No order</span>
                      <span>Only positioning to the given coordinate</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;1&apos; - Test order</span>
                      <span>
                        PLC delivers the occupation state of the specified
                        storage slot
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;2&apos; - Loading</span>
                      <span>Loading operation</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;3&apos; - Unloading</span>
                      <span>Unloading operation</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;4&apos; - Combined order</span>
                      <span>
                        Combined order: unloading on unload position, loading on
                        loading position
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;5&apos; - Load through</span>
                      <span>
                        Load through from input position to output position,
                        only on load-unload positions
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;R&apos; - Reset order</span>
                      <span>
                        Reset the actual order at the PLC (Attention: sequence
                        number always &apos;00&apos;)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;X&apos; - LDU blocked</span>
                      <span>LDU blocked (deactivated in PLC)</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td style={thTdStyle}>t</td>
                <td style={thTdStyle}>Byte 10</td>
                <td style={thTdStyle}>{inputValue.substring(9, 10)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 2 Order type
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 9 for descriptions.</td>
              </tr>
              <tr>
                <td style={thTdStyle}>q</td>
                <td style={thTdStyle}>Byte 11</td>
                <td style={thTdStyle}>{inputValue.substring(10, 11)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 1 Order feedback
                  </div>
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;P&apos; - Positive completion</span>
                      <span>Positive completion of given order</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;A&apos; - Other sequence active</span>
                      <span>
                        Order with other (former) sequence number is active at
                        PLC
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;H&apos; - Height error</span>
                      <span>
                        Height error (TU on fork is too high for given
                        coordinate)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;B&apos; - Width error</span>
                      <span>
                        Width error (TU on fork is too wide for given
                        coordinate)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;I&apos; - Length error</span>
                      <span>
                        Length error (TU on fork is too long for given
                        coordinate)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;W&apos; - Weight error</span>
                      <span>
                        Weight error (TU on fork is too heavy for given
                        coordinate)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;L&apos; - Storage slot empty</span>
                      <span>
                        Storage slot empty (crane action executed), only if
                        order type is ´1´ or type of feedback reaction is ‘2’
                        (without fault indication)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;V&apos; - Storage slot occupied</span>
                      <span>Storage slot occupied</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;X&apos; - Occupation error</span>
                      <span>
                        Occupation error (NO crane action executed), required
                        occupation state is not equal to real occupation state
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;U&apos; - Unexecutable order</span>
                      <span>
                        Unexecutable order, e.g., wrong occupation of storage
                        slot
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>
                        &apos;1&apos; - Storage slot occupied at depth 1
                      </span>
                      <span>
                        Storage slot is occupied at depth 1, only if order type
                        is ´1´
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>
                        &apos;2&apos; - Storage slot occupied at depth 2
                      </span>
                      <span>
                        Storage slot is occupied at depth 2, only if order type
                        is ´1´
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;G&apos; - Storage slot locked</span>
                      <span>Storage slot locked (constructional locked)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;K&apos; - Wrong coordinates</span>
                      <span>Wrong coordinates (invalid value range)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;D&apos; - Wrong double order</span>
                      <span>Wrong double order (only if two forks exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;R&apos; - Acknowledge reset</span>
                      <span>
                        Acknowledge to order type ‘R’ (reset from MFC)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;N&apos; - Reset done</span>
                      <span>Reset done by PLC in TEVIS</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;S&apos; - Jam/fault</span>
                      <span>
                        Jam/fault, because “ready to transfer”- signal is
                        missing (order not executed)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;J&apos; - Jam/crane</span>
                      <span>
                        Jam/crane, because blocked by other crane on rail (order
                        terminated)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;C&apos; - Collision</span>
                      <span>
                        Collision LDU, at shared storage location (racks). 2
                        cranes can access same location. (e.g. sequence buffer
                        OPM V2.0)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;$&apos; - Logical fault</span>
                      <span>
                        Logical fault in order (e.g., unload of two TU in depth
                        1, wrong order type)
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>q</td>
                <td style={thTdStyle}>Byte 12</td>
                <td style={thTdStyle}>{inputValue.substring(11, 12)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 2 Order feedback
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 11 for descriptions.</td>
              </tr>

              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 13</td>
                <td style={thTdStyle}>{inputValue.substring(12, 13)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  Reduction in speed for X-axis
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos;</span>
                      <span>Reduction in speed by 0% from maximum speed</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;1&apos;</span>
                      <span>
                        Reduction in speed by 6.25% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;2&apos;</span>
                      <span>
                        Reduction in speed by 12.50% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;3&apos;</span>
                      <span>
                        Reduction in speed by 18.75% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;4&apos;</span>
                      <span>
                        Reduction in speed by 25.00% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;5&apos;</span>
                      <span>
                        Reduction in speed by 31.25% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;6&apos;</span>
                      <span>
                        Reduction in speed by 37.50% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;7&apos;</span>
                      <span>
                        Reduction in speed by 43.75% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;8&apos;</span>
                      <span>
                        Reduction in speed by 50.00% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;9&apos;</span>
                      <span>
                        Reduction in speed by 56.25% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;:&apos;</span>
                      <span>
                        Reduction in speed by 62.50% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;;&apos;</span>
                      <span>
                        Reduction in speed by 68.75% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;&lt;&apos;</span>
                      <span>
                        Reduction in speed by 75.00% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;=&apos;</span>
                      <span>
                        Reduction in speed by 81.25% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;&gt;&apos;</span>
                      <span>
                        Reduction in speed by 87.50% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;?&apos;</span>
                      <span>
                        Reduction in speed by 93.75% from maximum speed
                      </span>
                    </div>
                  </div>
                </td>
              </tr>

              {/* Byte 14: LDU 1 Reduction in speed (refer to Byte 13 for descriptions) */}
              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 14</td>
                <td style={thTdStyle}>{inputValue.substring(13, 14)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1 Reduction in speed
                </td>
                <td style={thTdStyle}>See Byte 13 for descriptions.</td>
              </tr>

              {/* Byte 15: LDU 2 Reduction in speed (refer to Byte 13 for descriptions) */}
              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 15</td>
                <td style={thTdStyle}>{inputValue.substring(14, 15)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 2 Reduction in speed
                </td>
                <td style={thTdStyle}>See Byte 13 for descriptions.</td>
              </tr>

              {/* Byte 16: Type of feedback reaction */}
              <tr>
                <td style={thTdStyle}>T</td>
                <td style={thTdStyle}>Byte 16</td>
                <td style={thTdStyle}>{inputValue.substring(15, 16)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  Type of feedback reaction
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos;</span>
                      <span>
                        Feedback message after operation with fault indication
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;1&apos;</span>
                      <span>
                        Feedback message during operation with fault indication
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;2&apos;</span>
                      <span>
                        Feedback message after operation without fault
                        indication
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;3&apos;</span>
                      <span>
                        Feedback message during operation without fault
                        indication
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;4&apos;</span>
                      <span>No ‘S’ response output position</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;8&apos;</span>
                      <span>
                        No height check while loading from input position
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>xxx</td>
                <td style={thTdStyle}>Byte 17-19</td>
                <td style={thTdStyle}>{inputValue.substring(16, 19)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  X-coordinate of source
                </td>
                <td style={thTdStyle}>&apos;000&apos;..&apos;254&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>yyy</td>
                <td style={thTdStyle}>Byte 20-22</td>
                <td style={thTdStyle}>{inputValue.substring(19, 22)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  Y-coordinate of source
                </td>
                <td style={thTdStyle}>&apos;000&apos;..&apos;254&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>z</td>
                <td style={thTdStyle}>Byte 23</td>
                <td style={thTdStyle}>{inputValue.substring(22, 23)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1 Rack side order
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos;</span>
                      <span>
                        No side: only in conjunction with order type
                        &apos;0&apos;
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;L&apos;</span>
                      <span>Left rack side</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;R&apos;</span>
                      <span>Right rack side</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;L&apos;, &apos;R&apos;</span>
                      <span>
                        If order type &apos;4&apos;, then rack side of the
                        unload position. If order type &apos;5&apos;, then rack
                        side of the load position.
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>aa</td>
                <td style={thTdStyle}>Byte 24-25</td>
                <td style={thTdStyle}>{inputValue.substring(23, 25)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1 Number of TU to load/unload
                </td>
                <td style={thTdStyle}>&apos;00&apos;..&apos;99&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ttt</td>
                <td style={thTdStyle}>Byte 26-28</td>
                <td style={thTdStyle}>{inputValue.substring(25, 28)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1 Load depth
                </td>
                <td style={thTdStyle}>&apos;000&apos;..&apos;254&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>Z</td>
                <td style={thTdStyle}>Byte 29</td>
                <td style={thTdStyle}>{inputValue.substring(28, 29)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 2 Rack side order
                </td>
                <td style={thTdStyle}>
                  Use Byte 23&apos;s logic for Byte 29 as LDU 2&apos;s rack side
                  order mirrors LDU 1&apos;s logic
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>aa</td>
                <td style={thTdStyle}>Byte 30-31</td>
                <td style={thTdStyle}>{inputValue.substring(29, 31)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 2 Number of TU to load/unload
                </td>
                <td style={thTdStyle}>&apos;00&apos;..&apos;99&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ttt</td>
                <td style={thTdStyle}>Byte 32-34</td>
                <td style={thTdStyle}>{inputValue.substring(31, 34)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 2 Load depth
                </td>
                <td style={thTdStyle}>&apos;000&apos;..&apos;254&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>s</td>
                <td style={thTdStyle}>Byte 35</td>
                <td style={thTdStyle}>{inputValue.substring(34, 35)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1: Nominal occupation before order start or real
                  occupation if order feedback (Byte 11) = &apos;X&apos;
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>Bit 0</span>
                      <span>LDU occupied</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 1</span>
                      <span>Place 1 occupied</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 2</span>
                      <span>Place 2 occupied (if exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 3</span>
                      <span>Place 3 occupied (if exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 4</span>
                      <span>Place 4 occupied (if exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 5</span>
                      <span>Place 5 occupied (if exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 6</span>
                      <span>fixed 1</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 7</span>
                      <span>fixed 0</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>ih</td>
                <td style={thTdStyle}>Byte 37-44</td>
                <td style={thTdStyle}>{inputValue.substring(36, 44)}</td>
                <td style={thTdStyle}>
                  <div>
                    LDU 1 real occupation pattern if order feedback (byte 11) =
                    <div style={{ marginLeft: "20px" }}>
                      <div>
                        • &apos;X&apos; Occupation error (precedence if
                        &apos;H&apos; as well)
                      </div>
                      <div>• &apos;H&apos; Height error</div>
                    </div>
                  </div>
                </td>
                <td style={thTdStyle}>
                  <div>
                    <div>
                      <b>Tray type (Byte 37)</b>
                    </div>
                    <div>&apos;-&apos;: Not occupied</div>
                    <div>
                      &apos;a&apos;: Lower case small tray ¼ of LDU capacity
                    </div>
                    <div>
                      &apos;B&apos;: UPPER case large tray ½ of LDU capacity
                    </div>
                    <div>&apos;a&apos;: Tray type 1</div>
                    <div>&apos;B&apos;: Tray type 2</div>
                    <div>
                      &apos;x&apos;: PLC has not measured tray (small tray ¼ of
                      LDU capacity)
                    </div>
                    <div>
                      &apos;X&apos;: PLC has not measured tray (large tray ½ of
                      LDU capacity)
                    </div>
                    <div>
                      &apos;y&apos;: Wrong orientation of small tray ¼ of LDU
                      (unload to conveyor, DON&apos;T unload to storage
                      location)
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      <b>Tray height (Byte 38)</b>
                    </div>
                    <div>&apos;-&apos;: Not occupied</div>
                    <div>&apos;1&apos;: Tray height 1</div>
                    <div>&apos;2&apos;: Tray height 2</div>
                    <div>&apos;3&apos;: Tray height 3</div>
                    <div>&apos;9&apos;: Tray overheight</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>bh</td>
                <td style={thTdStyle}>Byte 47-54</td>
                <td style={thTdStyle}>{inputValue.substring(46, 54)}</td>
                <td style={thTdStyle}>
                  <div>
                    LDU 1 occupation pattern of tus to be moved
                    <div style={{ marginLeft: "20px" }}>
                      <div>
                        • &apos;X&apos; Occupation error (precedence if
                        &apos;H&apos; as well)
                      </div>
                      <div>• &apos;H&apos; Height error</div>
                    </div>
                  </div>
                </td>
                <td style={thTdStyle}>
                  <div>
                    <div>
                      <b>Tray type</b>
                    </div>
                    <div>&apos;-&apos;: Not occupied</div>
                    <div>
                      &apos;+&apos;: Occupied but tu not moved by current order
                    </div>
                    <div>
                      &apos;a&apos;: Lower case small tray ¼ of LDU capacity
                    </div>
                    <div>
                      &apos;B&apos;: UPPER case large tray ½ of LDU capacity
                    </div>
                    <div>&apos;a&apos;: Tray type 1</div>
                    <div>&apos;B&apos;: Tray type 2</div>
                    <div style={{ marginTop: "10px" }}>
                      <b>Tray height (See Byte 38)</b>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>|</td>
                <td style={thTdStyle}>Byte 55</td>
                <td style={thTdStyle}>{inputValue.substring(54, 55)}</td>
                <td style={thTdStyle}>&apos;|&apos;</td>
                <td style={thTdStyle}>Delimiter</td>
              </tr>
              <tr>
                <td style={thTdStyle}>p..p</td>
                <td style={thTdStyle}>Byte 56-67</td>
                <td style={thTdStyle}>{inputValue.substring(55, 67)}</td>
                <td style={thTdStyle} colSpan="2">
                  TU 1 Identification number (MFC default if not occupied)
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>|</td>
                <td style={thTdStyle}>Byte 68</td>
                <td style={thTdStyle}>{inputValue.substring(67, 68)}</td>
                <td style={thTdStyle}>&apos;|&apos;</td>
                <td style={thTdStyle}>Delimiter</td>
              </tr>
              <tr>
                <td style={thTdStyle}>q..q</td>
                <td style={thTdStyle}>Byte 69-81</td>
                <td style={thTdStyle}>{inputValue.substring(68, 81)}</td>
                <td style={thTdStyle} colSpan="2">
                  TU 2 Identification number
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>|</td>
                <td style={thTdStyle}>Byte 82</td>
                <td style={thTdStyle}>{inputValue.substring(81, 82)}</td>
                <td style={thTdStyle}>&apos;|&apos;</td>
                <td style={thTdStyle}>Delimiter</td>
              </tr>
              <tr>
                <td style={thTdStyle}>p..p</td>
                <td style={thTdStyle}>Byte 83-94</td>
                <td style={thTdStyle}>{inputValue.substring(82, 94)}</td>
                <td style={thTdStyle} colSpan="2">
                  TU 3 Identification number
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>|</td>
                <td style={thTdStyle}>Byte 95</td>
                <td style={thTdStyle}>{inputValue.substring(94, 95)}</td>
                <td style={thTdStyle}>&apos;|&apos;</td>
                <td style={thTdStyle}>Delimiter</td>
              </tr>
              <tr>
                <td style={thTdStyle}>q..q</td>
                <td style={thTdStyle}>Byte 96-107</td>
                <td style={thTdStyle}>{inputValue.substring(95, 107)}</td>
                <td style={thTdStyle} colSpan="2">
                  TU 4 Identification number
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>{inputValue.substring(107)}</td>
                <td style={thTdStyle}>REST</td>
                <td style={thTdStyle}>From 107 onwards</td>
                <td style={thTdStyle}>TBD</td>
                <td style={thTdStyle}>
                  All remaining characters for the telegram
                </td>
              </tr>
            </tbody>
          </table>
        </>
      ) : null}

      {selection === "Format 50" ? (
        <>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Enter text here42"
            style={{
              padding: "10px",
              margin: "10px 0",
              width: "calc(100% - 22px)",
            }}
          />
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thTdStyle}>Placeholder</th>
                <th style={thTdStyle}>Byte Location</th>
                <th style={thTdStyle}>Value</th>
                <th style={thTdStyle}>Description</th>{" "}
                {/* Renamed as requested */}
                <th style={thTdStyle}>Description of Values</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={thTdStyle}>qq</td>
                <td style={thTdStyle}>Byte 1-2</td>
                <td style={thTdStyle}>{inputValue.substring(0, 2)}</td>
                <td style={thTdStyle}>
                  &apos;00&apos; - &apos;99&apos;, or MF
                </td>
                <td style={thTdStyle}>Source of message (GC Group Control)</td>
              </tr>
              <tr>
                <td style={thTdStyle}>zz</td>
                <td style={thTdStyle}>Byte 3-4</td>
                <td style={thTdStyle}>{inputValue.substring(2, 4)}</td>
                <td style={thTdStyle}>
                  &apos;00&apos; - &apos;99&apos;, or MF
                </td>
                <td style={thTdStyle}>Destination of message</td>
              </tr>
              <tr>
                <td style={thTdStyle}>mm</td>
                <td style={thTdStyle}>Byte 5-6</td>
                <td style={thTdStyle}>{inputValue.substring(4, 6)}</td>
                <td style={thTdStyle}>&apos;00&apos; - &apos;99&apos;</td>
                <td style={thTdStyle}>Meldepunkt/Action Point</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ll</td>
                <td style={thTdStyle}>Byte 7-8</td>
                <td style={thTdStyle}>{inputValue.substring(6, 8)}</td>
                <td style={thTdStyle}>&apos;00&apos; - &apos;99&apos;</td>
                <td style={thTdStyle}>Laufnummer/Process number</td>
              </tr>
              <tr>
                <td style={thTdStyle}>t</td>
                <td style={thTdStyle}>Byte 9</td>
                <td style={thTdStyle}>{inputValue.substring(8, 9)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 1 Order type
                  </div>
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos; - No order</span>
                      <span>Only positioning to the given coordinate</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;1&apos; - Test order</span>
                      <span>
                        PLC delivers the occupation state of the specified
                        storage slot
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;2&apos; - Loading</span>
                      <span>Loading operation</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;3&apos; - Unloading</span>
                      <span>Unloading operation</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;4&apos; - Combined order</span>
                      <span>
                        Combined order: unloading on unload position, loading on
                        loading position
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;5&apos; - Load through</span>
                      <span>
                        Load through from input position to output position,
                        only on load-unload positions
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;R&apos; - Reset order</span>
                      <span>
                        Reset the actual order at the PLC (Attention: sequence
                        number always &apos;00&apos;)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;X&apos; - LDU blocked</span>
                      <span>LDU blocked (deactivated in PLC)</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td style={thTdStyle}>t</td>
                <td style={thTdStyle}>Byte 10</td>
                <td style={thTdStyle}>{inputValue.substring(9, 10)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 2 Order type
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 9 for descriptions.</td>
              </tr>
              <tr>
                <td style={thTdStyle}>q</td>
                <td style={thTdStyle}>Byte 11</td>
                <td style={thTdStyle}>{inputValue.substring(10, 11)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 1 Order feedback
                  </div>
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;P&apos; - Positive completion</span>
                      <span>Positive completion of given order</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;A&apos; - Other sequence active</span>
                      <span>
                        Order with other (former) sequence number is active at
                        PLC
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;H&apos; - Height error</span>
                      <span>
                        Height error (TU on fork is too high for given
                        coordinate)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;B&apos; - Width error</span>
                      <span>
                        Width error (TU on fork is too wide for given
                        coordinate)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;I&apos; - Length error</span>
                      <span>
                        Length error (TU on fork is too long for given
                        coordinate)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;W&apos; - Weight error</span>
                      <span>
                        Weight error (TU on fork is too heavy for given
                        coordinate)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;L&apos; - Storage slot empty</span>
                      <span>
                        Storage slot empty (crane action executed), only if
                        order type is &apos;1&apos; or type of feedback reaction
                        is &apos;2&apos; (without fault indication)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;V&apos; - Storage slot occupied</span>
                      <span>Storage slot occupied</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;X&apos; - Occupation error</span>
                      <span>
                        Occupation error (NO crane action executed), required
                        occupation state is not equal to real occupation state
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;E&apos; - PLC fault at last order</span>
                      <span>
                        PLC fault at last order (NO crane action executed) -
                        Interruption of PLC “automatic mode” since or at last
                        order execution, like inPos disturbance flag
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;U&apos; - Unexecutable order</span>
                      <span>
                        Unexecutable order, e.g., wrong occupation of storage
                        slot
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>
                        &apos;1&apos; - Storage slot occupied at depth 1
                      </span>
                      <span>
                        Storage slot is occupied at depth 1, only if order type
                        is &apos;1&apos;
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>
                        &apos;2&apos; - Storage slot occupied at depth 2
                      </span>
                      <span>
                        Storage slot is occupied at depth 2, only if order type
                        is &apos;1&apos;
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;G&apos; - Storage slot locked</span>
                      <span>Storage slot locked (constructional locked)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;K&apos; - Wrong coordinates</span>
                      <span>Wrong coordinates (invalid value range)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;D&apos; - Wrong double order</span>
                      <span>Wrong double order (only if two forks exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;R&apos; - Acknowledge reset</span>
                      <span>
                        Acknowledge to order type ‘R’ (reset from MFC)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;N&apos; - Reset done</span>
                      <span>Reset done by PLC in TEVIS</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;S&apos; - Jam/fault</span>
                      <span>
                        Jam/fault, because “ready to transfer”- signal is
                        missing (order not executed)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;J&apos; - Jam/crane</span>
                      <span>
                        Jam/crane, because blocked by other crane on rail (order
                        terminated)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;O&apos; - Obstructed location by crane</span>
                      <span>
                        Obstructed (versperrt) location by crane ON neighbour
                        rail. Collision LDU, at shared storage location (racks).
                        2 cranes can access same location. (e.g., sequence
                        buffer OPM V2.0 or PML-OCB at boots)
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;_&apos; - No action for 2nd LDU</span>
                      <span>
                        Only if 2 LDU; no action: order for LDU not executed
                        e.g., S: ..32__.. LDU 1 unload, LDU 2 load R: ..32_X..
                        or _V, V_
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;$&apos; - Logical fault</span>
                      <span>
                        Logical fault in order (e.g., unload of two TU in depth
                        1, wrong order type)
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>q</td>
                <td style={thTdStyle}>Byte 12</td>
                <td style={thTdStyle}>{inputValue.substring(11, 12)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 2 Order feedback
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 11 for descriptions.</td>
              </tr>

              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 13</td>
                <td style={thTdStyle}>{inputValue.substring(12, 13)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  Reduction in speed for X-axis
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos;</span>
                      <span>Reduction in speed by 0% from maximum speed</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;1&apos;</span>
                      <span>
                        Reduction in speed by 6.25% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;2&apos;</span>
                      <span>
                        Reduction in speed by 12.50% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;3&apos;</span>
                      <span>
                        Reduction in speed by 18.75% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;4&apos;</span>
                      <span>
                        Reduction in speed by 25.00% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;5&apos;</span>
                      <span>
                        Reduction in speed by 31.25% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;6&apos;</span>
                      <span>
                        Reduction in speed by 37.50% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;7&apos;</span>
                      <span>
                        Reduction in speed by 43.75% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;8&apos;</span>
                      <span>
                        Reduction in speed by 50.00% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;9&apos;</span>
                      <span>
                        Reduction in speed by 56.25% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;:&apos;</span>
                      <span>
                        Reduction in speed by 62.50% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;;&apos;</span>
                      <span>
                        Reduction in speed by 68.75% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;&lt;&apos;</span>
                      <span>
                        Reduction in speed by 75.00% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;=&apos;</span>
                      <span>
                        Reduction in speed by 81.25% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;&gt;&apos;</span>
                      <span>
                        Reduction in speed by 87.50% from maximum speed
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;?&apos;</span>
                      <span>
                        Reduction in speed by 93.75% from maximum speed
                      </span>
                    </div>
                  </div>
                </td>
              </tr>

              {/* Byte 14: LDU 1 Reduction in speed (refer to Byte 13 for descriptions) */}
              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 14</td>
                <td style={thTdStyle}>{inputValue.substring(13, 14)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1 Reduction in speed
                </td>
                <td style={thTdStyle}>See Byte 13 for descriptions.</td>
              </tr>

              {/* Byte 15: LDU 2 Reduction in speed (refer to Byte 13 for descriptions) */}
              <tr>
                <td style={thTdStyle}>r</td>
                <td style={thTdStyle}>Byte 15</td>
                <td style={thTdStyle}>{inputValue.substring(14, 15)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 2 Reduction in speed
                </td>
                <td style={thTdStyle}>See Byte 13 for descriptions.</td>
              </tr>

              {/* Byte 16: Type of feedback reaction */}
              <tr>
                <td style={thTdStyle}>T</td>
                <td style={thTdStyle}>Byte 16</td>
                <td style={thTdStyle}>{inputValue.substring(15, 16)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  Type of feedback reaction
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos;</span>
                      <span>
                        Feedback message after operation with fault indication
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;1&apos;</span>
                      <span>
                        Feedback message during operation with fault indication
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;2&apos;</span>
                      <span>
                        Feedback message after operation without fault
                        indication
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;3&apos;</span>
                      <span>
                        Feedback message during operation without fault
                        indication
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;4&apos;</span>
                      <span>
                        Feedback message after operation with fault indication
                        aisle exchange empty after load order
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>xxx</td>
                <td style={thTdStyle}>Byte 17-19</td>
                <td style={thTdStyle}>{inputValue.substring(16, 19)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  X-coordinate of source
                </td>
                <td style={thTdStyle}>&apos;000&apos;..&apos;254&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>yyy</td>
                <td style={thTdStyle}>Byte 20-22</td>
                <td style={thTdStyle}>{inputValue.substring(19, 22)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  Y-coordinate of source
                </td>
                <td style={thTdStyle}>&apos;000&apos;..&apos;254&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>z</td>
                <td style={thTdStyle}>Byte 23</td>
                <td style={thTdStyle}>{inputValue.substring(22, 23)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1 Rack side order
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>&apos;0&apos;</span>
                      <span>
                        No side: only in conjunction with order type
                        &apos;0&apos;
                      </span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;L&apos;</span>
                      <span>Left rack side</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;R&apos;</span>
                      <span>Right rack side</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>&apos;L&apos;, &apos;R&apos;</span>
                      <span>
                        If order type &apos;4&apos;, then rack side of the
                        unload position. If order type &apos;5&apos;, then rack
                        side of the load position.
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>aa</td>
                <td style={thTdStyle}>Byte 24-25</td>
                <td style={thTdStyle}>{inputValue.substring(23, 25)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1 Number of TU to load/unload
                </td>
                <td style={thTdStyle}>&apos;00&apos;..&apos;99&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ttt</td>
                <td style={thTdStyle}>Byte 26-28</td>
                <td style={thTdStyle}>{inputValue.substring(25, 28)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1 Load depth
                </td>
                <td style={thTdStyle}>&apos;000&apos;..&apos;254&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>Z</td>
                <td style={thTdStyle}>Byte 29</td>
                <td style={thTdStyle}>{inputValue.substring(28, 29)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 2 Rack side order
                </td>
                <td style={thTdStyle}>
                  Use Byte 23&apos;s logic for Byte 29 as LDU 2&apos;s rack side
                  order mirrors LDU 1&apos;s logic
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>aa</td>
                <td style={thTdStyle}>Byte 30-31</td>
                <td style={thTdStyle}>{inputValue.substring(29, 31)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 2 Number of TU to load/unload
                </td>
                <td style={thTdStyle}>&apos;00&apos;..&apos;99&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ttt</td>
                <td style={thTdStyle}>Byte 32-34</td>
                <td style={thTdStyle}>{inputValue.substring(31, 34)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 2 Load depth
                </td>
                <td style={thTdStyle}>&apos;000&apos;..&apos;254&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>s</td>
                <td style={thTdStyle}>Byte 35</td>
                <td style={thTdStyle}>{inputValue.substring(34, 35)}</td>
                <td style={{ ...thTdStyle, fontWeight: "bold" }}>
                  LDU 1: Nominal occupation before order start or real
                  occupation if order feedback (Byte 11) = &apos;X&apos;
                </td>
                <td style={thTdStyle}>
                  <div style={nestedDescriptionStyle}>
                    <div style={nestedItemStyle}>
                      <span>Bit 0</span>
                      <span>LDU occupied</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 1</span>
                      <span>Place 1 occupied</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 2</span>
                      <span>Place 2 occupied (if exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 3</span>
                      <span>Place 3 occupied (if exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 4</span>
                      <span>Place 4 occupied (if exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 5</span>
                      <span>Place 5 occupied (if exist)</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 6</span>
                      <span>fixed 1</span>
                    </div>
                    <div style={nestedItemStyle}>
                      <span>Bit 7</span>
                      <span>fixed 0</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>ih</td>
                <td style={thTdStyle}>Byte 37-44</td>
                <td style={thTdStyle}>{inputValue.substring(36, 44)}</td>
                <td style={thTdStyle}>
                  <div>
                    LDU 1 real occupation pattern if order feedback (byte 11) =
                    <div style={{ marginLeft: "20px" }}>
                      <div>
                        • &apos;X&apos; Occupation error (precedence if
                        &apos;H&apos; as well)
                      </div>
                      <div>• &apos;H&apos; Height error</div>
                    </div>
                  </div>
                </td>
                <td style={thTdStyle}>
                  <div>
                    <div>
                      <b>Tray type (Byte 37)</b>
                    </div>
                    <div>&apos;-&apos;: Not occupied</div>
                    <div>
                      &apos;a&apos;: Lower case small tray ¼ of LDU capacity
                    </div>
                    <div>
                      &apos;B&apos;: UPPER case large tray ½ of LDU capacity
                    </div>
                    <div>&apos;a&apos;: Tray type 1</div>
                    <div>&apos;B&apos;: Tray type 2</div>
                    <div>
                      &apos;x&apos;: PLC has not measured tray (small tray ¼ of
                      LDU capacity)
                    </div>
                    <div>
                      &apos;X&apos;: PLC has not measured tray (large tray ½ of
                      LDU capacity)
                    </div>
                    <div>
                      &apos;y&apos;: Wrong orientation of small tray ¼ of LDU
                      (unload to conveyor, DON&apos;T unload to storage
                      location)
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      <b>Tray height (Byte 38)</b>
                    </div>
                    <div>&apos;-&apos;: Not occupied</div>
                    <div>&apos;1&apos;: Tray height 1</div>
                    <div>&apos;2&apos;: Tray height 2</div>
                    <div>&apos;3&apos;: Tray height 3</div>
                    <div>&apos;9&apos;: Tray overheight</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>&lt;</td>
                <td style={thTdStyle}>Byte 45</td>
                <td style={thTdStyle}>{inputValue.substring(44, 45)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    Delimiter
                  </div>
                </td>
                <td style={thTdStyle}>&apos;&lt;&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>@</td>
                <td style={thTdStyle}>Byte 46</td>
                <td style={thTdStyle}>{inputValue.substring(45, 46)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 1 action control code (OPM V2.0)
                  </div>
                </td>
                <td style={thTdStyle}>&apos;@&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>bh</td>
                <td style={thTdStyle}>Byte 47-54</td>
                <td style={thTdStyle}>{inputValue.substring(46, 54)}</td>
                <td style={thTdStyle}>
                  <div>
                    LDU 1 occupation pattern of tus to be moved
                    <div style={{ marginLeft: "20px" }}>
                      <div>
                        • &apos;X&apos; Occupation error (precedence if
                        &apos;H&apos; as well)
                      </div>
                      <div>• &apos;H&apos; Height error</div>
                    </div>
                  </div>
                </td>
                <td style={thTdStyle}>
                  <div>
                    <div>
                      <b>Tray type</b>
                    </div>
                    <div>&apos;-&apos;: Not occupied</div>
                    <div>
                      &apos;+&apos;: Occupied but tu not moved by current order
                    </div>
                    <div>
                      &apos;a&apos;: Lower case small tray ¼ of LDU capacity
                    </div>
                    <div>
                      &apos;B&apos;: UPPER case large tray ½ of LDU capacity
                    </div>
                    <div>&apos;a&apos;: Tray type 1</div>
                    <div>&apos;B&apos;: Tray type 2</div>
                    <div style={{ marginTop: "10px" }}>
                      <b>Tray height (See Byte 38)</b>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>L2</td>
                <td style={thTdStyle}>Byte 55-56</td>
                <td style={thTdStyle}>{inputValue.substring(54, 56)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 2 Delimiter
                  </div>
                </td>
                <td style={thTdStyle}>&apos;L2&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>ih..</td>
                <td style={thTdStyle}>Byte 57-64</td>
                <td style={thTdStyle}>{inputValue.substring(56, 64)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 2 occupation pattern before order start
                  </div>
                </td>
                <td style={thTdStyle}>
                  See Bytes 37 and 38 for tray type and height
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>&lt;</td>
                <td style={thTdStyle}>Byte 65</td>
                <td style={thTdStyle}>{inputValue.substring(64, 65)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    Delimiter
                  </div>
                </td>
                <td style={thTdStyle}>&apos;&lt;&apos;</td>
              </tr>
              <tr>
                <td style={thTdStyle}>@</td>
                <td style={thTdStyle}>Byte 66</td>
                <td style={thTdStyle}>{inputValue.substring(65, 66)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 2 action control code (OPM V2.0)
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 46</td>
              </tr>
              <tr>
                <td style={thTdStyle}>bh..</td>
                <td style={thTdStyle}>Byte 67-74</td>
                <td style={thTdStyle}>{inputValue.substring(66, 74)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    LDU 2 occupation pattern of tus to be moved
                  </div>
                </td>
                <td style={thTdStyle}>
                  See Bytes 47 and 48 for tray type and height
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>|</td>
                <td style={thTdStyle}>Byte 75</td>
                <td style={thTdStyle}>{inputValue.substring(74, 75)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    Delimiter
                  </div>
                </td>
                <td style={thTdStyle}>
                  Depending on LDU action control code (byte 46 or 66), Bit 2
                  ’D’: use scanner options ’P’, ’*’, ’-’
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>p..p</td>
                <td style={thTdStyle}>Byte 76-87</td>
                <td style={thTdStyle}>{inputValue.substring(75, 87)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    TU 1 Identification number
                  </div>
                </td>
                <td style={thTdStyle}>
                  MFC default if not occupied, PLC default or specific PLC
                  barcode label read based on scanner feedback in Byte 75
                </td>
              </tr>
              <tr>
                <td style={thTdStyle}>|</td>
                <td style={thTdStyle}>Byte 88</td>
                <td style={thTdStyle}>{inputValue.substring(87, 88)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    Delimiter
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 75</td>
              </tr>
              <tr>
                <td style={thTdStyle}>q..q</td>
                <td style={thTdStyle}>Byte 89-100</td>
                <td style={thTdStyle}>{inputValue.substring(88, 100)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    TU 2 Identification number
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 76-87 for pattern</td>
              </tr>
              <tr>
                <td style={thTdStyle}>|</td>
                <td style={thTdStyle}>Byte 101</td>
                <td style={thTdStyle}>{inputValue.substring(100, 101)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    Delimiter
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 75</td>
              </tr>
              <tr>
                <td style={thTdStyle}>p..p</td>
                <td style={thTdStyle}>Byte 102-113</td>
                <td style={thTdStyle}>{inputValue.substring(101, 113)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    TU 3 Identification number
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 76-87 for pattern</td>
              </tr>
              <tr>
                <td style={thTdStyle}>|</td>
                <td style={thTdStyle}>Byte 114</td>
                <td style={thTdStyle}>{inputValue.substring(113, 114)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    Delimiter
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 75</td>
              </tr>
              <tr>
                <td style={thTdStyle}>q..q</td>
                <td style={thTdStyle}>Byte 115-126</td>
                <td style={thTdStyle}>{inputValue.substring(114, 126)}</td>
                <td style={thTdStyle}>
                  <div style={{ ...nestedItemStyle, fontWeight: "bold" }}>
                    TU 4 Identification number
                  </div>
                </td>
                <td style={thTdStyle}>See Byte 76-87 for pattern</td>
              </tr>
              <tr>
                <td style={thTdStyle}>{inputValue.substring(126)}</td>
                <td style={thTdStyle}>REST</td>
                <td style={thTdStyle}>From 126 onwards</td>
                <td style={thTdStyle}>TBD</td>
                <td style={thTdStyle}>
                  All remaining characters for the telegram
                </td>
              </tr>
            </tbody>
          </table>
        </>
      ) : null}

      {selection === "Inbound and Conveyors" ? <div>To be done</div> : null}
    </div>
  );
}

export default TelegramDecoder;
